import { Textarea } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

type DatasetsNotesProps = {
  notes: string | undefined
  onClick: () => void
}

const DatasetsNotes = ({ notes, onClick }: DatasetsNotesProps) => {
  const { t } = useTranslation()

  return (
    <Textarea
      label={t('Notes')}
      type="text"
      value={notes}
      maxLength={255}
      rows={3}
      readOnly
      onClick={onClick}
      title={t('Click to edit notes')}
      id="dataset-notes"
    />
  )
}

export default DatasetsNotes
